export default function LegalPage() {
  return (
    <div className="min-h-screen bg-zinc-50" data-testid="legal-page">
      {/* Header */}
      <div className="bg-white border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="font-['Outfit'] text-4xl sm:text-5xl tracking-tight font-light text-zinc-900">
            Mentions <span className="font-medium">légales</span>
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white border border-zinc-200 p-8 space-y-8" data-testid="legal-content">
          
          {/* Éditeur */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              1. Éditeur du site
            </h2>
            <div className="text-zinc-600 space-y-2 text-sm leading-relaxed">
              <p><strong>Raison sociale :</strong> IMMOSTAGING</p>
              <p><strong>Forme juridique :</strong> Société par actions simplifiée (SAS)</p>
              <p><strong>SIRET :</strong> 892 344 680 00012</p>
              <p><strong>Siège social :</strong> Route du Regage, 13124 Peypin, France</p>
              <p><strong>Téléphone :</strong> 07 66 02 00 20</p>
              <p><strong>Email :</strong> contactsite@immostaging.fr</p>
              <p><strong>Directeur de la publication :</strong> Gilles FOUQUE</p>
            </div>
          </section>

          {/* Carte professionnelle */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              2. Carte professionnelle
            </h2>
            <div className="text-zinc-600 space-y-2 text-sm leading-relaxed">
              <p>Carte professionnelle n° CPI 1301 2019 000 040 614</p>
              <p>Délivrée par la CCI Aix-Marseille-Provence</p>
              <p><strong>Activités :</strong> Transactions sur immeubles et fonds de commerce</p>
              <p><strong>Garantie financière :</strong> Beazley solutions international limited
75009 PARIS</p>
              
              <p><strong>Assurance RCP :</strong> Beazley solutions international limited
75009 PARIS 9</p>
            </div>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              3. Hébergement
            </h2>
            <div className="text-zinc-600 space-y-2 text-sm leading-relaxed">
              <p>Ce site est hébergé par :</p>
              <p><strong>Contabo</strong></p>
              <p>Service d'hébergement cloud</p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              4. Propriété intellectuelle
            </h2>
            <div className="text-zinc-600 text-sm leading-relaxed space-y-3">
              <p>
                L'ensemble du contenu de ce site (textes, images, vidéos, logos, etc.) est protégé par 
                le droit d'auteur et reste la propriété exclusive d'IMMOSTAGING ou de ses partenaires.
              </p>
              <p>
                Toute reproduction, distribution, modification ou utilisation de ces éléments, 
                en tout ou partie, sans autorisation écrite préalable est strictement interdite.
              </p>
            </div>
          </section>

          {/* Données personnelles */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              5. Protection des données personnelles
            </h2>
            <div className="text-zinc-600 text-sm leading-relaxed space-y-3">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi 
                Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, 
                de suppression et d'opposition aux données vous concernant.
              </p>
              <p>
                Les données collectées via les formulaires de contact sont utilisées uniquement 
                pour répondre à vos demandes et vous tenir informé de nos services. 
                Elles ne sont jamais cédées à des tiers.
              </p>
              <p>
                <strong>Responsable du traitement :</strong> IMMOSTAGING<br />
                <strong>Contact DPO :</strong> contactsite@immostaging.fr
              </p>
              <p>
                Pour exercer vos droits, contactez-nous par email à contactsite@immostaging.fr 
                ou par courrier à l'adresse du siège social.
              </p>
            </div>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              6. Cookies
            </h2>
            <div className="text-zinc-600 text-sm leading-relaxed space-y-3">
              <p>
                Ce site utilise des cookies techniques nécessaires à son bon fonctionnement. 
                Ces cookies ne collectent aucune donnée personnelle à des fins publicitaires.
              </p>
              <p>
                Vous pouvez configurer votre navigateur pour refuser les cookies, mais certaines 
                fonctionnalités du site pourraient ne plus être accessibles.
              </p>
            </div>
          </section>

          {/* Médiation */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              7. Médiation de la consommation
            </h2>
            <div className="text-zinc-600 text-sm leading-relaxed space-y-3">
              <p>
                Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, 
                en cas de litige, vous pouvez recourir gratuitement au service de médiation :
              </p>
              <p>
                <strong>Médiateur de la consommation :</strong> ANM Conso<br />
                62 rue Tiquetonne, 75002 Paris<br />
                <a href="https://www.anm-conso.com" className="text-[#D62965] hover:underline" target="_blank" rel="noopener noreferrer">
                  www.anm-conso.com
                </a>
              </p>
            </div>
          </section>

          {/* Crédits */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-medium text-zinc-900 mb-4">
              8. Crédits
            </h2>
            <div className="text-zinc-600 text-sm leading-relaxed">
              
              <p><strong>Photos :</strong> IMMOSTAGING / Unsplash</p>
            </div>
          </section>

          {/* Mise à jour */}
          <div className="pt-6 border-t border-zinc-200">
            <p className="text-xs text-zinc-400">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
